// extracted by css-extract-rspack-plugin
export default {"cls1":"Bookmarkers-cls1_dux","cls2":"Bookmarkers-cls2_5Ex Bookmarkers-cls1_dux"};